import { useSearchParams } from "react-router-dom"
import WithSidebar from "../../../layouts/WithSidebar"
import RefundConfirmationForm from "../../../components/Refund-confirmation"


const RefundConfirmation = () => {

    const [searchParams, setSearchParams] = useSearchParams()
    const id = searchParams.get('id')

    return (
        <WithSidebar breadcrumb={'Dashboard > Payment Management > Refund Detail'} pageTitle={'Refund Detail'}>
            <RefundConfirmationForm  />
        </WithSidebar>
    )
}

export default RefundConfirmation